export const validateSurname = (value: string) => {
  if (!value || value.trim() === "") {
    return "Campo obrigatório";
  }

  if (value.length === 1) {
    return /^[a-zA-Z0-9]$/.test(value)
      ? true
      : "Este campo não é permitido uma única letra ou números";
  }

  const charsAllowed = ["'", "´", "-", "."];
  const chars = value.split("");

  for (let i = 0; i < chars.length; i += 1) {
    if (
      i > 0 &&
      charsAllowed.includes(chars[i]) &&
      charsAllowed.includes(chars[i - 1])
    ) {
      return "Nome inválido.";
    }

    if (
      chars[i] !== " " &&
      !/^[a-zA-ZÀ-ÿ0-9]+$/.test(chars[i]) &&
      !charsAllowed.includes(chars[i])
    ) {
      return "Nome inválido.";
    }
  }

  return true;
};
